import { useState } from "react";
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDProgress from "components/MDProgress";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";

function Projects({ data }) {
  const { doneThisMonthLabel, rows: projectRows } = data;
  const [menu, setMenu] = useState(null);

  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      <MenuItem onClick={closeMenu}>Action</MenuItem>
      <MenuItem onClick={closeMenu}>Another action</MenuItem>
      <MenuItem onClick={closeMenu}>Something else</MenuItem>
    </Menu>
  );

  const columns = [
    { Header: "companies", accessor: "companies", width: "45%", align: "left" },
    { Header: "members", accessor: "members", width: "10%", align: "left" },
    { Header: "budget", accessor: "budget", align: "center" },
    { Header: "completion", accessor: "completion", align: "center" },
  ];

  const rows = projectRows.map((project) => ({
    companies: (
      <MDTypography variant="button" fontWeight="medium">
        {project.company}
      </MDTypography>
    ),
    members: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {project.membersCount} members
      </MDTypography>
    ),
    budget: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {project.budget}
      </MDTypography>
    ),
    completion: (
      <MDBox width="8rem" textAlign="left">
        <MDProgress
          value={project.completion}
          color={project.completion >= 100 ? "success" : "info"}
          variant="gradient"
          label={false}
        />
      </MDBox>
    ),
  }));

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            Projects
          </MDTypography>
          <MDBox display="flex" alignItems="center" lineHeight={0}>
            <Icon
              sx={{
                fontWeight: "bold",
                color: ({ palette: { info } }) => info.main,
                mt: -0.5,
              }}
            >
              done
            </Icon>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;<strong>{doneThisMonthLabel}</strong> this month
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox color="text" px={2}>
          <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={openMenu}>
            more_vert
          </Icon>
        </MDBox>
        {renderMenu}
      </MDBox>
      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />
      </MDBox>
    </Card>
  );
}

Projects.propTypes = {
  data: PropTypes.shape({
    doneThisMonthLabel: PropTypes.string,
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        company: PropTypes.string,
        membersCount: PropTypes.number,
        budget: PropTypes.string,
        completion: PropTypes.number,
      })
    ),
  }),
};

Projects.defaultProps = {
  data: { doneThisMonthLabel: "30 done", rows: [] },
};

export default Projects;
